import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function MountainBand({ label, id }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["0px", "-240px"]);
  return (
    <div ref={ref} className="relative overflow-hidden bg-[#BEE7EC]" data-testid={`mountain-band-${id}`}>
      <div className="wrap pb-4 pt-12 lg:pt-16">
        <p className="eyebrow flex items-center gap-3 text-forest-deep">
          <span className="h-px w-10 bg-forest-deep/60" />{label}
        </p>
      </div>
      <motion.div
        aria-hidden="true"
        className="h-[96px] sm:h-[140px] lg:h-[180px]"
        style={{
          backgroundImage: "url(/assets/mountains-tile.webp)",
          backgroundRepeat: "repeat-x",
          backgroundSize: "auto 100%",
          backgroundPositionX: x,
        }}
      />
    </div>
  );
}
